/** @jsxImportSource @emotion/react */
import { Avatar } from "@mui/material"

type Props = {
  name: string
  image: string
}

const TierIcon = ({ name, image }: Props) => {
  return <Avatar alt={name} src={image} sx={{ width: 18, height: 18 }} />
}

export default TierIcon
